import { css } from '@emotion/react';

export const sectionContainer = css`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const sectionHeader = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.5px;
`;

export const sectionContent = css`
    padding: 4px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
`;

export const option = css`
    display: flex;
    align-items: center;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    transition: all 0.2s ease;

    &:hover {
        background: #f8f9fa;
        border-color: #adb5bd;
    }
`;

export const optionName = css`
    margin-left: 8px;
    font-size: 12px;
    color: #495057;
`;

export const divider = css`
    width: 100%;
    height: 1px;
    background-color: #e9ecef;
    margin: 8px 0;
`;
